import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { of, Subscription, catchError, tap } from 'rxjs';

import { ValidationService } from '@tablesready/common-ui';
import { ChangePassword } from '../../models';
import { AlertsService } from '@tablesready/frontend-alerts-bar';
import { UserApiService } from '@tablesready/frontend-auth';

@Component({
  selector: 'tablesready-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  passwordForm: UntypedFormGroup;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly alertsService: AlertsService,
    private readonly validationService: ValidationService,
    private readonly userApiService: UserApiService,
  ) {}

  ngOnInit(): void {
    this.passwordForm = this.fb.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: ['', [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(100),
          this.validationService.passwordValidator(),
        ]],
        confirmPassword: ['', [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(100),
          this.validationService.passwordValidator(),
        ]],
      },
      {
        validators: this.password.bind(this),
      });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  submit(): void {
    const value = this.passwordForm.value;
    const options: ChangePassword = {
      old: value.oldPassword,
      new: value.newPassword,
      confirm: value.confirmPassword,
    };

    this.subscriptions.add(
      this.userApiService.updatePassword(options)
        .pipe(
          tap(() => {
            this.alertsService.addSuccess('account info updated successfully.');
            this.passwordForm.reset();
          }),
          catchError(error => {
            this.alertsService.addError(error.message || `${error.error.error}`);

            return of(null);
          }),
        ).subscribe(),
    );
  }

  private password(formGroup: UntypedFormGroup): { passwordNotMatch: boolean } | null {
    const { value: password } = formGroup.get('newPassword');
    const { value: confirmPassword } = formGroup.get('confirmPassword');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }
}
